module.exports = __webpack_public_path__ + "static/media/GradeCalculatorBack.24ec6ebc.png";